import { gql } from "@apollo/client";

/**
 * Single round trip for everything that decides the Hero banner's lead state:
 * contract (nocontract/valid/expired), warranty, industry segment, chamber path,
 * the asset id (events KPI filter) and the live connection status.
 * networkInformation is intentionally NOT included — it resolves noticeably
 * slower and streams in via AssetNetworkInfo instead.
 * iotHubConnectivityStatus must NEVER be selected here: when the backend's hub
 * lookup fails for a device it silently nulls the WHOLE iotConnection (no errors
 * entry), which would blind the lead state and clobber the cached connection
 * (verified against assetLocation 21489, 2026-08-06). It streams in tolerantly
 * via AssetIoTHubStatus instead.
 */
export const AssetDashboardHero = gql`
    query AssetDashboardHero($id: ID!) {
        assetLocation(id: $id) {
            id
            warrantyEndDate
            runtimeHours
            averageRuntimePerDay
            asset {
                id
            }
            installedBaseNode {
                id
                pathNodes {
                    id
                    title
                    nodeType {
                        key
                    }
                }
            }
            owner {
                id
                industryType
                contract {
                    id
                    contractDurationFrom
                    contractDurationTo
                }
            }
            iotConnection {
                id
                connectionStatus
            }
        }
    }
`;
